const filterProps = (props, pattern) => {
  const filteredProps = {};
  Object.keys(props).filter(key => pattern.test(key))
  .map(key => filteredProps[key] = props[key]);
  return filteredProps;
}

export default filterProps;



// WEBPACK FOOTER //
// ./src/utils/filterProps.js